<template>
    <InputField
        :value="value"
        type="email"
        :label="label"
        :disabled="disabled"
        :description="description"
        :help-button-text="helpButtonText"
        :required="required"
        :placeholder="placeholder"
        :error-messages="errorMessages"
        :status="status"
        @input="$emit('input', $event)"
        @change="$emit('change', $event)"
        @blur="$emit('blur', $event)"
    />
</template>
<script setup lang="ts">
import InputField from './InputField.vue';

type EmailFieldProps = {
    value: string;
    label: string;
    disabled?: boolean;
    description?: string;
    helpButtonText?: string;
    required?: boolean;
    placeholder?: string;
    errorMessages?: string[];
    status?: 'overridden';
};

defineProps<EmailFieldProps>();
defineEmits<{ (e: 'input', v: Event): void; (e: 'change', v: Event): void; (e: 'blur', v: Event): void }>();
</script>
